<template>
    <v-container fluid grid-list-md fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Вход в систему</v-toolbar-title>
                    </v-toolbar>
                    <v-alert
                            :value="alert"
                            color="error"
                            icon="warning"

                    >
                        {{error_text}}
                    </v-alert>
                    <v-form v-model="valid" ref="form">
                        <v-card-text>
                            <v-text-field prepend-icon="fa-user" v-model="login.username" @keyup.enter="geturl" :rules="usernameRules" type="text" required>
                            </v-text-field>
                            <v-text-field prepend-icon="fa-lock" v-model="login.password" @keyup.enter="geturl" :rules="passwordRules" counter type="password" :error-messages="passwordError" required>
                            </v-text-field>
                        </v-card-text>
                        <v-card-actions class="login-block">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="geturl">Войти</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import axios from 'axios'
    export default {

        data()  {
            return{
                alert: false,
                valid: false,
                successAlert:false,
                error_text: '',
                passwordError:'',
                passwordRules: [
                    (v) => !!v || 'Пароль обязателен'

                ],
                usernameRules: [
                    (v) => !!v || 'Логин сотрудника обязателен'
                ],
                username: '',
                password: '',
                login:{
                    username:'',
                    password:''
                },
            }
        },
        mounted() {
            let token = localStorage.getItem('token');
            if(token) {
                this.$router.push('/requests');
            }
        },
        methods:{
            geturl(){
                // localStorage.setItem('url', 'http://mmsk.tech:8082');
                // this.loginIt('http://mmsk.tech:8082')

                axios({
                    method: 'get',
                    url: 'https://api.ipify.org/?format=json',
                }).then(response => {
                    let ip = response.data.ip
                    if(ip == "46.160.209.240"){
                        localStorage.setItem('url', 'http://192.168.10.2:8085');
                        this.loginIt('http://192.168.10.2:8085')
                    }else{
                        localStorage.setItem('url', 'http://int.el-zakupki.ru:8085');
                        this.loginIt('http://int.el-zakupki.ru:8085')
                    }

                }).catch(() => {
                    axios({
                        method: 'get',
                        url: 'http://www.geoplugin.net/json.gp',
                    }).then(response => {
                        let ip2 = response.data.geoplugin_request
                        if(ip2 == "46.160.209.240"){
                            localStorage.setItem('url', 'http://192.168.10.2:8085');
                            this.loginIt('http://192.168.10.2:8085')
                        }else{
                            localStorage.setItem('url', 'http://int.el-zakupki.ru:8085');
                            this.loginIt('http://int.el-zakupki.ru:8085')
                        }
                    })
                });
            },
            loginIt(url){
                if (this.$refs.form.validate()) {
                    axios({
                        method: 'get',
                        url: url + '/api/users/byUsername/' + this.login.username,
                        withCredentials: true,
                        auth: {
                            username: this.login.username,
                            password: this.login.password,
                        }
                    }).then(response => {
                        this.alert = false;
                        let token = btoa(this.login.username + ':' + this.login.password);
                        let auth_user = this.login.username;
                        let user_customerId = response.data.customerId;
                        let user_uuid = response.data.uuid;
                        let user_id = response.data.id;
                        let role = response.data.role;

                        localStorage.setItem('auth_user', auth_user);
                        localStorage.setItem('token', token);
                        localStorage.setItem('user_customerId', user_customerId);
                        localStorage.setItem('user_uuid', user_uuid);
                        localStorage.setItem('user_id', user_id);
                        localStorage.setItem('role', role);

                        Event.$emit('login');
                        this.$router.push('/requests');
                    })
                    .catch(error =>{
                        let errors = error.response.data.message;
                        if(errors.password)
                        {
                            this.passwordError = errors.password;
                            this.alert = false;
                            this.error_text = '';
                        }else {
                            this.error_text = errors;
                            this.passwordError = '';
                            this.alert = true;
                        }

                    });
                }

            },

        }
    }
</script>
<style scoped>
    .login-block{
        padding-bottom: 20px;
    }
</style>

